import { render, staticRenderFns } from "./PhysicalVault.vue?vue&type=template&id=398abe0a&"
import script from "./PhysicalVault.vue?vue&type=script&lang=js&"
export * from "./PhysicalVault.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalVault.vue?vue&type=style&index=0&id=398abe0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports